import { ScreenState } from "./screen";
import { Drawable } from "./drawable";
import { SVG } from "./image";
import { rgb, rgba } from "../utils/color";
import { easeInCubic, easeInSine, easeOutCubic } from "easing-utils";
import GroupedComponent from "./groupedComponent";
import { shuffleArray } from "../utils/common";

export default class AlbumArt extends Drawable{
  currentSongPreviewStart = undefined;
  currentSongPreviewEnd = undefined;
  lastLoopTrigger = undefined;
  playPressed = false;
  // This function will set when there is a new song to change to.
  changeSongCallback = /** @type {undefined | Promise<any>} */(undefined);
  // The above function must modify currentSongPreviewStart, currentSongPreviewEnd and set player position manually.


  /**
  * Initialiases the Static Text drawable.
  * @param {SVG} icon The Icon to diplay before the text.
  * @param {string} title The song title.
  * @param {string} artist The artist.
  * @param {import("textalive-app-api").IPlayer} player The textalive player object
  * @param {SVG[]} bgIcons A list of icons to display in the background. Must be an odd number of icons
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(icon, title, artist, difficulty, player, bgIcons, configureCanvas){
    super(710, 365, configureCanvas);
    this.icon = icon;
    this.title = title;
    this.artist = artist;
    this.difficulty = difficulty;
    this.player = player;
    this.bgIcons = bgIcons;
    this.width = 437;
    this.height = 430;
  }

  stopMusicNow(){
    console.log('stopCalled')
    this.currentSongPreviewEnd = this.player.timer.position;// + 1000
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){

    //Handle Audio Looping
    if (screenState.playerPosition && this.currentSongPreviewStart && this.currentSongPreviewEnd){
      const fadeInPreviewEndsMs = this.currentSongPreviewStart + 1000;
      const fadeOutPreviewEndsMs = this.currentSongPreviewEnd + 750;

      if (this.lastLoopTrigger > screenState.playerPosition){// Song has looped, reset loopTriggerStatus
        this.lastLoopTrigger = undefined;
      }

      if (screenState.playerPosition <= fadeInPreviewEndsMs){
        this.player.volume = easeInCubic(Math.max(1-(fadeInPreviewEndsMs - screenState.playerPosition)/1000, 0))*100;
        // console.log(this.player.volume);
      }
      else if (screenState.playerPosition > fadeInPreviewEndsMs && screenState.playerPosition <= this.currentSongPreviewEnd){
        this.player.volume = 100;
      }
      else if (screenState.playerPosition <= fadeOutPreviewEndsMs){
        this.player.volume = easeInCubic((fadeOutPreviewEndsMs - screenState.playerPosition)/750)*100;
        // console.log(this.player.volume);
      }
      else if (!this.lastLoopTrigger && screenState.playerPosition > (fadeOutPreviewEndsMs)){
        console.log('loopCall');
        this.lastLoopTrigger = screenState.playerPosition;
        if (this.changeSongCallback){
          this.changeSongCallback()
          this.changeSongCallback = undefined;
          // As mentioned earlier, the above function must modify currentSongPreviewStart, currentSongPreviewEnd and set player position manually.
        }
        else{
          this.player.requestMediaSeek(this.currentSongPreviewStart-500);
        }
      }
      else{
        this.player.volume = 0;
      }
    }

  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    super.render(screenState);

    // Background
    screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
    screenState.canvasCtx.fillStyle = "#FFD966";
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.rect(screenState.offsetX, screenState.offsetY, screenState.width, screenState.height);
    screenState.canvasCtx.fill();
    
    screenState.canvasCtx.globalAlpha = screenState.transitionProgress/2;
    const bgIconsSize = screenState.height/10;
    const bgIconsMovementAmount = screenState.animationStep/3000%this.bgIcons.length;
    const bgIconsOffset = bgIconsSize*bgIconsMovementAmount;
    const offScreenAmt = bgIconsSize*this.bgIcons.length
    let iconIndex = 0;
    let moveLeft = screenState.animationStep/3000%(this.bgIcons.length*2) >= this.bgIcons.length;
    for (let i = -offScreenAmt; i < (screenState.height+offScreenAmt); i += bgIconsSize){
      for (let j = -offScreenAmt; j < (screenState.width+offScreenAmt); j += bgIconsSize){
        // if (iconIndex%this.bgIcons.length == 0){
        //   // this.bgIcons = shuffleArray(this.bgIcons);
        //   [this.bgIcons[0], this.bgIcons[this.bgIcons.length-1]] = [this.bgIcons[this.bgIcons.length-1], this.bgIcons[0]]
        // }
        this.bgIcons[iconIndex%this.bgIcons.length].render(screenState.canvasCtx, j + bgIconsSize/2 + (moveLeft ? -bgIconsOffset : bgIconsOffset ), i + bgIconsSize/2 + bgIconsOffset, bgIconsSize, bgIconsSize, rgba(100,100,100, screenState.transitionProgress/2));
        iconIndex++;
      }
      moveLeft = !moveLeft;
    }
    
    
    screenState.canvasCtx.globalAlpha = screenState.transitionProgress;


    const mp3PlayerDisplayArt = new GroupedComponent(435, 0, 550, 696, screenState);

    screenState.canvasCtx.fillStyle = rgb(88, 192, 235);
    screenState.canvasCtx.lineWidth = 0
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(93, 45, 57, 70), [10]);
    // screenState.canvasCtx.fill();
    screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(18, 130, 57, 147), [10]);
    screenState.canvasCtx.fill();
    
    screenState.canvasCtx.fillStyle = rgb(5,213,3)
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.rect(...mp3PlayerDisplayArt.rectResizeV2(408, 0, 22, 50));
    screenState.canvasCtx.fill();
    screenState.canvasCtx.fillStyle = rgb(15,223,23)
    screenState.canvasCtx.strokeStyle = 'white'
    screenState.canvasCtx.lineWidth = 2
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(394, 30, 49, 123), [25]);
    screenState.canvasCtx.fill();
    screenState.canvasCtx.stroke();
       
    screenState.canvasCtx.fillStyle = rgb(108, 212, 255);
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(28, 56, 494, 640), [60]);
    screenState.canvasCtx.fill();
    screenState.canvasCtx.stroke();
    
    // const [rextX, rextY] = [screenState.X(492), screenState.Y(85)];
    // const [rectWidth, rectHeight] = [screenState.S(this.width*screenState.transitionProgress), screenState.S(this.height*screenState.transitionProgress)]
    const iconSize = screenState.S(75);
    const [centreX, centreY] = [screenState.X(this.x), screenState.Y(this.y)];
    screenState.canvasCtx.fillStyle = 'blue';
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(57, 85, this.width, this.height), [50]);
    screenState.canvasCtx.fill();
    // screenState.canvasCtx.stroke();
    
    const centreY2 = screenState.Y(294);
    screenState.canvasCtx.font = `bold ${screenState.S(45)}px Yusei Magic`;
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    const txtBounding = screenState.canvasCtx.measureText(this.title);
    const txtHeight = txtBounding.actualBoundingBoxAscent + txtBounding.actualBoundingBoxDescent;
    const timeSinceInit = screenState.animationStep - this.initTime; 
    const textColor = rgba(255,255, 255, timeSinceInit >= 750 && this.playPressed ? 1 : screenState.transitionProgress);
    this.icon.render(screenState.canvasCtx, centreX, centreY2 - txtHeight - iconSize/2, iconSize, iconSize, textColor);
    // screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillStyle = textColor
    //750 is Screen Transition Time. We don't want outro animation when play is pressed.
    screenState.canvasCtx.fillText(this.title, centreX, centreY2);
    screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`;
    const txtBounding2 = screenState.canvasCtx.measureText(this.artist);
    const txtHeight2 = txtBounding2.actualBoundingBoxAscent + txtBounding2.actualBoundingBoxDescent;
    // screenState.canvasCtx.fillStyle = rgba(255,255, 255, screenState.transitionProgress);
    screenState.canvasCtx.fillText(this.artist, centreX, centreY2 + txtHeight + 10);
    // screenState.canvasCtx.fill();
    // screenState.canvasCtx
    
    screenState.canvasCtx.fillText(this.difficulty, centreX, centreY2 + txtHeight + txtHeight2 + 20);
    screenState.canvasCtx.globalAlpha = 1;
  }
}